import { column, Schema, Table } from '@powersync/common';

export const MuscleTargetTable = new Table({
    muscle: column.text,
    muscleGroup: column.text,
    sportActivityId: column.text,
    userId: column.text,
    intensity: column.integer,
    createdAt: column.text,
    updatedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const SportActivityTable = new Table({
    name: column.text,
    userId: column.text,
    categoryId: column.text,
    externalId: column.text,
    defaultDimensions: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const WorkoutTable = new Table({
    userId: column.text,
    niceId: column.text,
    clonedFromId: column.text,
    name: column.text,
    note: column.text,
    difficulty: column.integer,
    duration: column.integer,
    plannedAt: column.text,
    startedAt: column.text,
    finishedAt: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"],
    niceId_index: ["niceId"],
    clonedFromId_index: ["clonedFromId"]
  } });
export const WorkoutSupersetTable = new Table({
    workoutId: column.text,
    sortIndex: column.integer,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const WorkoutExerciseTable = new Table({
    supersetId: column.text,
    sportActivityId: column.text,
    definedDimensions: column.text,
    workoutId: column.text,
    sortIndex: column.integer,
    note: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const WorkoutExerciseDimensionTable = new Table({
    exerciseId: column.text,
    dimension: column.text,
    unit: column.text,
    workoutId: column.text,
    createdAt: column.text,
    updatedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const WorkoutSetTable = new Table({
    exerciseId: column.text,
    workoutId: column.text,
    sortIndex: column.integer,
    completedAt: column.text,
    createdAt: column.text,
    updatedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const WorkoutSetValueTable = new Table({
    setId: column.text,
    exerciseDimensionId: column.text,
    value: column.real,
    workoutId: column.text,
    createdAt: column.text,
    updatedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const RecordedSessionTable = new Table({
    source: column.text,
    externalId: column.text,
    startedAt: column.text,
    endedAt: column.text,
    avgHeartRate: column.integer,
    maxHeartRate: column.integer,
    activeCalories: column.real,
    recordedDuration: column.integer,
    workoutId: column.text,
    userId: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const BodyMeasurementTable = new Table({
    source: column.text,
    externalId: column.text,
    measuredAt: column.text,
    weight: column.real,
    bodyFatPercent: column.real,
    leanMass: column.real,
    userId: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const SportActivityCategoryTable = new Table({
    title: column.text,
    shortDescription: column.text,
    description: column.text,
    externalId: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const MealCategoryTable = new Table({
    title: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const MealAllergenTable = new Table({
    title: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const MealLogTable = new Table({
    userId: column.text,
    niceId: column.text,
    mealId: column.text,
    consumedAmount: column.real,
    consumedAmountUnit: column.text,
    consumedAt: column.text,
    mealType: column.text,
    createdAt: column.text,
    updatedAt: column.text
},
  { indexes: {
    id_index: ["id"],
    niceId_index: ["niceId"]
  } });
export const ChatTable = new Table({
    userId: column.text,
    niceId: column.text,
    context: column.text,
    contextRefId: column.text,
    name: column.text,
    createdAt: column.text,
    updatedAt: column.text,
    deletedAt: column.text
},
  { indexes: {
    id_index: ["id"],
    niceId_index: ["niceId"]
  } });
export const ChatMessageTable = new Table({
    userId: column.text,
    createdAt: column.text,
    chatId: column.text,
    sender: column.text,
    metadata: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const ChatMessagePartTable = new Table({
    userId: column.text,
    messageId: column.text,
    chatId: column.text,
    order: column.integer,
    type: column.text,
    text: column.text,
    kind: column.text,
    payloadJson: column.text,
    createdAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const ChatPlanTable = new Table({
    userId: column.text,
    chatId: column.text,
    taskDescription: column.text,
    status: column.text,
    startedAt: column.text,
    terminatedAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });
export const ChatPlanStepTable = new Table({
    userId: column.text,
    chatPlanId: column.text,
    chatId: column.text,
    stepIndex: column.integer,
    title: column.text,
    instructions: column.text,
    dependencies: column.text,
    status: column.text,
    result: column.text,
    startedAt: column.text,
    completedAt: column.text,
    createdAt: column.text
},
  { indexes: {
    id_index: ["id"]
  } });

export const AppSchema = new Schema({
  MuscleTarget: MuscleTargetTable,
  SportActivity: SportActivityTable,
  Workout: WorkoutTable,
  WorkoutSuperset: WorkoutSupersetTable,
  WorkoutExercise: WorkoutExerciseTable,
  WorkoutExerciseDimension: WorkoutExerciseDimensionTable,
  WorkoutSet: WorkoutSetTable,
  WorkoutSetValue: WorkoutSetValueTable,
  RecordedSession: RecordedSessionTable,
  BodyMeasurement: BodyMeasurementTable,
  SportActivityCategory: SportActivityCategoryTable,
  MealCategory: MealCategoryTable,
  MealAllergen: MealAllergenTable,
  MealLog: MealLogTable,
  Chat: ChatTable,
  ChatMessage: ChatMessageTable,
  ChatMessagePart: ChatMessagePartTable,
  ChatPlan: ChatPlanTable,
  ChatPlanStep: ChatPlanStepTable
});

export type Database = (typeof AppSchema)["types"];
export type AppSchemaType = typeof AppSchema;

export type MuscleTargetRecord = Database['MuscleTarget'];
export type SportActivityRecord = Database['SportActivity'];
export type WorkoutRecord = Database['Workout'];
export type WorkoutSupersetRecord = Database['WorkoutSuperset'];
export type WorkoutExerciseRecord = Database['WorkoutExercise'];
export type WorkoutExerciseDimensionRecord = Database['WorkoutExerciseDimension'];
export type WorkoutSetRecord = Database['WorkoutSet'];
export type WorkoutSetValueRecord = Database['WorkoutSetValue'];
export type RecordedSessionRecord = Database['RecordedSession'];
export type BodyMeasurementRecord = Database['BodyMeasurement'];
export type SportActivityCategoryRecord = Database['SportActivityCategory'];
export type MealCategoryRecord = Database['MealCategory'];
export type MealAllergenRecord = Database['MealAllergen'];
export type MealLogRecord = Database['MealLog'];
export type ChatRecord = Database['Chat'];
export type ChatMessageRecord = Database['ChatMessage'];
export type ChatMessagePartRecord = Database['ChatMessagePart'];
export type ChatPlanRecord = Database['ChatPlan'];
export type ChatPlanStepRecord = Database['ChatPlanStep'];
